<div
  class="multi-chat-navigation__card p-5 p-md-3"
  [ngClass]="{'multi-chat-navigation_active': isTicketChosen}"
>
  <div class="d-flex">
    <div class="w-100">
      <div class="d-flex mb-6">
        <div
          class="card-avatar rounded-1 me-4 overflow-hidden d-flex position-relative align-items-center justify-content-center">
          <img [src]="ticket.expert_photo" alt="avatar" class="position-absolute h-100" (error)="errorHandler($event)">
        </div>
        <div>
          <p class="mb-0 card-time">
            {{(ticket.created_at * 1000) | date:'MMM d, h:mm a'}}
          </p>
          <p class="text-primblack card-status">
            <ng-template
              [ngIf]="status.lookingAnExpert"
            >
              Estimated wait time
              <span class="text-primgreen">
                {{(ticket.estimate_time.time_to_lock.time_to_lock_for_user_real / 60) | number: '1.0-0'}} MIN
              </span>
            </ng-template>
            <ng-template
              [ngIf]="status.solvingYourTask"
            >
              Estimated wait time
              <span class="text-primgreen">
                {{(ticket.estimate_time.time_to_solve.time_to_solve_for_user_real / 60) | number: '1.0-0'}} MIN
              </span>
            </ng-template>
            <ng-template
              [ngIf]="status.topUpCoins"
            >
              You have
              <span class="d-inline-block border border-1 border-black px-2 text-black bg-primyellow" style="border-radius: 4px">
                0 coins
              </span>
              left
            </ng-template>
            <ng-template
              [ngIf]="status.checkSolution"
            >
              There's solution in your task
            </ng-template>
            <ng-template
              [ngIf]="status.waitingForReply"
            >
              Waiting for a reply from expert
            </ng-template>
            <ng-template
              [ngIf]="status.checkSolutionWithFeedback"
            >
              Your task is solved
            </ng-template>
            <ng-template
              [ngIf]="status.reply"
            >
              We have a question about your task
            </ng-template>
            <ng-template
              [ngIf]="status.solved"
            >
              Your task is solved
            </ng-template>
            <ng-template
              [ngIf]="status.openTask"
            >
              Please check your task
            </ng-template>
            <ng-template
              [ngIf]="status.checkMessage"
            >
              You have new message from expert
            </ng-template>
          </p>
        </div>
      </div>
      <div class="card-status fw-bold text-center d-flex justify-content-center align-items-center rounded-1 py-3 px-5"
           [ngClass]="{
           'bg-primblack': status.topUpCoins,
           'bg-secsel': status.lookingAnExpert || status.solvingYourTask || status.waitingForReply,
           'bg-primsalad': status.checkSolutionWithFeedback || status.solved || status.openTask,
           'bg-primyellow border border-1 border-primblack': status.checkSolution || status.reply || status.checkMessage
           }"
      >
        <ng-template
          [ngIf]="status.lookingAnExpert"
        >
          <img src="/assets/icons/progress_status/Looking.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Looking for an expert
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.solvingYourTask"
        >
          <img src="/assets/icons/progress_status/Solving.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Solving your task
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.topUpCoins"
        >
          <p class="mb-0 text-primwhite">
            + Top up coins to solve
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.checkSolution"
        >
          <img src="/assets/icons/progress_status/Check_Solution.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Check solution
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.waitingForReply"
        >
          <img src="/assets/icons/progress_status/Waiting.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Waiting for a reply
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.checkSolutionWithFeedback"
        >
          <img src="/assets/icons/progress_status/Check_Solution.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Check solution
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.reply"
        >
          <img src="/assets/icons/progress_status/Reply.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Reply
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.solved"
        >
          <img src="/assets/icons/progress_status/Solved.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Solved
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.openTask"
        >
          <img src="/assets/icons/progress_status/Open.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Open task
          </p>
        </ng-template>
        <ng-template
          [ngIf]="status.checkMessage"
        >
          <img src="/assets/icons/progress_status/Check_Message.svg" alt="icon" class="me-2">
          <p class="mb-0 text-primblack">
            Check message
          </p>
        </ng-template>
      </div>
    </div>
    <div
      class="card-preview rounded-1 ms-10 ms-md-7 overflow-hidden position-relative d-flex d-flex align-items-center justify-content-center">
      <img [src]="ticket.preview_photo" alt="preview" class="position-absolute h-100">
    </div>
  </div>
</div>
